<template>
  <div class="col-md-12">
    <div :ref="refName">
      <survey :survey="survey" v-if="validSurvey">
      </survey>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import * as SurveyVue from "survey-vue";
import {string} from "../../../static/DataTables-1.13.2/JSZip-2.5.0/jszip";

const Survey = SurveyVue.Survey
export default {
  name: 'SurveyComponent',
  components: {
    Survey,
  },
  props: {
    surveyJson: {
      type: [String, Object],
      required: true,
    },
    refName: {
      type: String,
      default: 'surveyContainer'
    },
    surveyResult: {
      type: [String, Object, null],
      default: ''
    },
    saveKey: {
      type: String,
      default: 'survey_key'
    },
    onCompletingCallback: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
      loading: true,
      resetSurvey: false,
      survey: {},
      validSurvey: false,
      popupViewModel: null  // 👈 define so Vue knows it exists
    }
  },
  created() {
  },
  updated() {
    console.log('updated')
  },
  computed: {
    ...mapGetters(['accountid', 'accountName', 'username', 'id', 'language']),
  },
  watch: {
    resetSurvey: function() {
      if (this.resetSurvey && this.survey) this.survey.clear(true, true)
    },
    surveyJson: 'initializeSurvey',
    surveyResult: 'initializeSurvey',
  },
  mounted() {
    this.saveMeta()
    this.initializeSurvey()
  },
  beforeDestroy() {
    if (this.survey && typeof this.survey.dispose === "function") {
      this.survey.dispose();
      this.survey = null;
    }
  },
  methods: {
    initializeSurvey() {
      console.log('Initializing survey');
      if (!this.surveyJson || Object.keys(this.surveyJson).length === 0) return;

      const model = new SurveyVue.Model(this.surveyJson);
      if (this.language === 'de') model.locale = 'de';
      else model.locale = 'en'

      const myCss = {
        question: {
          title: 'questiontitle',
          hasError: 'has-error'
        },
        navigationButton: 'button btn-lg',
        error: {
          root: 'alert alert-danger',
          icon: 'glyphicon glyphicon-exclamation-sign',
          item: '',
          locationTop: 'sv_qstn_error_top',
          locationBottom: 'sv_qstn_error_bottom'
        }
      };

      model.onCompleting.add((sender, options) => {
        if (typeof this.onCompletingCallback === 'function') {
          this.onCompletingCallback(sender, options);
        }
      });

      model.onComplete.add((sender) => {
        this.$emit('surveyCompleted', sender.data);
      });

      model.onAfterRenderPage.add((sender, options) => {
        this.$emit('onAfterRenderPage', sender.data, options);
      });

      model.onValueChanged.add((sender, options) => {
        this.$emit('onValueChanged', sender, options);
        localStorage.setItem(this.saveKey + '.data', JSON.stringify(sender.data));
        localStorage.setItem(this.saveKey + '.page', sender.currentPageNo);
        localStorage.setItem(this.saveKey + '.modified', new Date().toLocaleString());
      });

      model.onAfterRenderQuestion.add((sender, options) => {
        if (options.htmlElement.querySelectorAll('.dkl-popover').length > 0) {
          const icon$ = $('.dkl-popover-icon');

          icon$.off('click').on('click', function (e) {
            e.preventDefault();
            let popover = $(this).next('.dkl-popover');
            popover.fadeIn(200);
            popover.css('left', `${$(this).position().left + $(this).width()}px`);
            popover.css('top', `${$(this).position().top}px`);
          });

          $(document).on('click', function (e) {
            if (e.target.closest('.dkl-popover') === null && e.target.closest('.dkl-popover-icon') === null) {
              $('.dkl-popover').css('display', 'none');
            }
          });
        }
      });

      model.css = myCss;
      model.completedHtml = '<p><h4>Danke für die Durchführung.</h4></p>';
      model.showPageTitles = true;
      model.clearInvisibleValues = 'onHidden';

      model.onTextMarkdown.add((sender, options) => {
        if (options.name === 'description' || options.name === 'text') options.html = options.text;
      });

      if (this.surveyResult) {
        let resultObject = {};
        try {
          if (typeof this.surveyResult === 'object') {
            resultObject = this.surveyResult;
          } else if (typeof this.surveyResult === 'string') {
            resultObject = JSON.parse(this.surveyResult);
          }
          model.data = resultObject;
          this.$emit('surveyResultLoaded', resultObject)
        } catch (error) {
          console.error("Error processing surveyResult:", error);
        }
      }

      this.survey = model;
      this.validSurvey = true;
    },
    saveMeta: function() {
      localStorage.setItem(this.saveKey + '.username', this.username)
      localStorage.setItem(this.saveKey + '.status', 'processing')
      localStorage.setItem(this.saveKey + '.modified', new Date().toLocaleString())
    },
  }
}
</script>

<style scoped>
  @import '../../assets/css/survey.css';
  #surveyContainer {
    font-family: Tahoma, Helvetica, Arial, sans-serif;
    text-align: left;
    font-size: 0.8rem;
}
  .questiontitle {
    font-size: 1rem;
  }
  .radio {
    font-size: 0.6rem;
  }
  .sv_q_erbox {
    background-color: red;
    color: red;
  }
  table {
  font-family: 'Tahoma', arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

  td, th {
  text-align: center;
  padding: 8px;
}

  tr:nth-child(even) {
  background-color: #dddddd;
}
  .ired {
    color: red
  }
  .igreen {
    color: green
  }
  h5.dialogtitle {
    color: #7a4c28;
    font-weight: bold;
  }

  .sd-root-modern {
    border-radius: 8px!important;
  }

  .sv_p_root > .sv_row {
    border-bottom: 1px solid #92be05;
  }
  .sv_p_root > .sv_row:nth-child(odd) {
      background-color: white;
    }

  .sv_p_root > .sv_row:nth-child(even) {
    background-color: #ebeef5;
  }
  .sv_p_root > .sv_page_title {
    font-weight: 900;
  }
  .sd-body .sd-body__page {
    margin-left: auto!important;
    margin-right: auto!important;
    max-width: fit-content!important;
  }
  .sd-element .sd-element-yes:hover {
    background-color: rgba(0,255,0,0.4);
  }
  .sd-element .sd-element-no:hover {
    background-color: rgba(255,0,0,0.4);
  }
  .surveyMenu {
    position: fixed;
    top: 80px;
    right: 20px;
  }
</style>
